import React, { Component } from 'react'
import { CommonDeleteButton, CommonEditButton, ConfirmPopup, DeletePopup, HighAlertDrugPopup } from '../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next';
import {
  Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, FormControl, IconButton, InputLabel, ListItem, ListItemText, MenuItem, Modal, Paper, Select, Table,
  TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography
} from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import ShowComponents from '../Common/ShowComponent';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { DateTime } from 'luxon';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Days, language, Months, Weeks, Year } from '../../../../Utility/Constants';
import ErrorIcon from '@mui/icons-material/Error';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DeleteIcon from '@mui/icons-material/Delete';

let showQty = false;
let is_save_transmit = false;
class DocPrescriptionLeft extends Component {
  constructor(props) {
    super(props)
    this.boxRef = React.createRef();
    this.state = {
      clinicId: localGetItem('SelectedDoctorClinicId'),
      prescriptionData: [],
      isDeleteCliked: false,
      SelectedList: {},
      PatientData: this.props?.PatientData,
      prevPrescripData: [],
      previousPrescripDate: [],
      prescriptionFav: [],
      prescriptionTemplateList: [],
      dupliPrescriptionData: "[]",
      selectedTemplate: "",
      SelectedEditIndex: null,
      languageList: language,
      selectedLanguage: 'english',
      Recalled: true,
      recallPopup: false,
      is_pharmacy: false,
      successPopup: false,
      successPopupTxt: '',
      smsSuccessTxt: '',
      isEditDuration: false,
      deleteTemplateName: null,
      deletePopup: false,
      removeData: false,
      grpEdit: false,
      selectedDays: '',
      selectedDuration: '1',
      tempSelectedDays: '',
      tempSelectedDuration: '1',
      hasAllergy: false,
      addPath: '',
      dupPrescriptionData: [],
      dupSelectedPharmacy: null,
      dupUpdateArray: [],
      match_generic_list: [],
      selectedPharmacy: null,
      selectedDrug: '',
      is_high_alert: false,
      is_look_alike: false,
      is_sound_alike: false,
      highAlert: false,
      lookAlikeDrugs: [],
      SoundAlikeDrugs: [],
      enable_drug_alert: false,
      selectedData: [],
      recallReason: '',
      recallError: '',
    }
  }

  componentDidMount() {
    // if (this.props.withOutAppointment?.patient_id !== this.props.withOutAppointment?.patient_id) {
    //     this.setState({ withOutAppointment: this.props.withOutAppointment })
    // }
    showQty = localGetItem('show_quantity_in_prescription') === 'true' ? true : false;
    is_save_transmit = localGetItem('prescription_save_transmit') === 'true' ? true : false;
    let hasPharmacy = JSON.parse(localGetItem('loggedInUserInfo'))?.pharmacy_data
    let enable_drug_alert = JSON.parse(localGetItem('enable_drug_alert'))
    this.setState({ is_pharmacy: hasPharmacy?.length === 0 ? true : false, enable_drug_alert: enable_drug_alert })
  }
  componentDidUpdate(prevprops, prevState) {
    if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.GetIntialData() }
    if (prevprops.PatientData !== this.props.PatientData) { this.setState({ PatientData: this.props.PatientData }, () => { this.GetIntialData() }) }
    if (prevprops.ClearClickedonRightPrecs !== this.props.ClearClickedonRightPrecs && this.props?.ClearClickedonRightPrecs) {
      this.setState({
        SelectedEditIndex: null
      }, () => { this.props.ClearPropsData() })
    }
    if (prevprops.AddPrescritionItem !== this.props.AddPrescritionItem && this.props.AddPrescritionItem?.length > 0) {
      if (this.state.SelectedEditIndex === null) {
        let Array = [...this.state.prescriptionData?.prescription_lines ? this.state.prescriptionData?.prescription_lines : [], ...this.props.AddPrescritionItem]
        this.state.prescriptionData.prescription_lines = Array
        this.setState({
          prescriptionData: this.state.prescriptionData,
          selectedPharmacy: Array?.length > 0 && Array[0]?.pharmacy_id ? Array[0]?.pharmacy_id : "",
        },
          () => { this.props.getPrescriptionData(Array) })
      } else {
        this.state.prescriptionData.prescription_lines[this.state.SelectedEditIndex] = this.props.AddPrescritionItem[0]
        this.setState({
          prescriptionData: this.state.prescriptionData, SelectedEditIndex: null,
          selectedPharmacy: (this.state.prescriptionData.prescription_lines?.length > 0 && this.state.prescriptionData.prescription_lines[0]?.pharmacy_id) ?
            this.state.prescriptionData.prescription_lines[0]?.pharmacy_id : "",
        },
          () => { this.props.getPrescriptionData(this.state.prescriptionData?.prescription_lines || []) })
      }
    }
    if(!prevState.openFav && this.state.openFav){
      this.getPrescriptionFavouriteData()
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }



  GetIntialData = () => {
    this.GetPrescriptionData()
    this.getPrescriptionFavouriteData()
    this.getPrescriptionListData()
    this.getPharmacyList()
  }

  postPrescriptionTransmit = (recalled) => {
    try {
      let data = {}
      if (recalled) {
        data = {
          appointment_id: this.state.PatientData?.appointment_id,
          prescription_id: this.state.prescriptionData?.prescription_id,
          is_recall: true,
          patient_id: this.state.PatientData?.patient_id,
          time: new Date().toISOString(),
          recalled_reason: this.state.recallReason
        }
      } else {
        data = {
          appointment_id: this.state.PatientData?.appointment_id,
          patient_id: this.state.PatientData?.patient_id,
          pharmacy_id: this.state?.selectedTransmitPharmacy ? this.state?.selectedTransmitPharmacy : this.state.selectedPharmacy || this.state.pharmacyList[0]?.pharmacy_id,
          prescription_id: this.state.prescriptionData?.prescription_id,
          time: new Date().toISOString(),
        }
      }
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TRANSMIT)
        .then((response) => {
          if (response.data.status === 'success') {
            let smsConfig = localGetItem("smsConfig") ? JSON.parse(localGetItem("smsConfig")) : {}
            if (!recalled && smsConfig?.prescription_sms) {
              this.setState({
                isEditDuration: false,
                successPopup: true,
                successPopupTxt: response.data.message,
                smsSuccessTxt: response.data.sms_message,
                recallReason: '', 
                recallError: ''
              })
            } else {
              this.setState({ isEditDuration: false })
              this.successMessage(response.data.message)
            }
            this.setState({ openTransmit: false, selectedTransmitPharmacy: '', transmitted: true, recallPopup: false }, () => {
              this.GetPrescriptionData()
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPharmacyList(prevPrescrip = false, formTransmit = false) {
    try {
      // RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PHARMACY_LIST_GET + `?clinic_id=${this.state.clinicId}&suggest=true`)
      //   .then((response) => {
      //     if (response.data.status === "success") {
      //       this.setState({
      //         pharmacyList: response.data?.data,
      //         selectedPharmacy: response?.data?.data[0]?.pharmacy_id
      //       }, () => {
      //         if (formTransmit) {
      //           if (response.data?.data?.length > 1) {
      //             this.setState({
      //               openTransmit: true
      //             })
      //           } else {
      //             this.postPrescriptionTransmit()
      //           }
      //         }
      //       })
      //     }
      //     else {
      //       this.errorMessage(response.data.message)
      //     }
      //   }).catch((error) => {
      //     this.errorMessage(error.message)
      //   })
      let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null;
      let pharmaList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)) : [];
      if (pharmaList?.length) {
        this.setState({
          pharmacyList: pharmaList,
          selectedPharmacy: pharmaList[0]?.pharmacy_id || ''
        })
      }
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postTemplate = () => {
    try {
      let data = {}
      if (this.state.tempType === 'Add') {
        let prescriptionList = []
        this.state.prescriptionData?.prescription_lines?.forEach(element => {
          prescriptionList?.push({
            afternoon: +element?.afternoon,
            dosage_strength: element?.dosage_strength,
            dosage_type: element?.dosage_type,
            drug_name: element?.brand_name,
            duration: element?.duration,
            duration_mode: element?.duration_mode,
            evening: +element?.evening,
            generic_name: element?.generic_name,
            instructions: element?.instructions,
            morning: +element?.morning,
            night: +element?.night,
            is_unit_ml: element?.is_unit_ml ? element?.is_unit_ml : element?.dosage_unit === "ML",
            pharmacy_id: element?.pharmacy_id ? element?.pharmacy_id : null,
            is_unit_others: element?.is_unit_others ? element?.is_unit_others : element?.dosage_unit === "Others",
            is_tapper_meds: element?.tapper_meds?.length === 0 ? false : true,
            tapper_meds: element?.tapper_meds ? element?.tapper_meds : [],
            is_external_drug: element?.is_external_drug ? element?.is_external_drug : false,
            dos_unit : element?.is_unit_ml ? "ML" : element?.is_unit_others ? "Others" : element?.dosage_unit ?? "Tablet",
            quantity: element?.quantity ? +element.quantity : 0,
          })
        })
        data = {
          pharmacy_id: this.state.selectedPharmacy,
          template_name: this.state.templateName,
          prescription: prescriptionList,
          clinic_id: +this.state.clinicId,
        }
      } else if (this.state.tempType === 'rename') {
        data = {
          template_name: this.state.templateName,
          template_id: this.state.selectedTemplate?.id,
          clinic_id: +this.state.clinicId,
        }
      }
      if (this.state.templateName === '') {
        this.errorMessage('Enter Template Name')
      } else {
        RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE)
          .then((response) => {
            if (response.data.status === 'success') {
              this.successMessage(response.data.message)
              this.getPrescriptionListData()
              this.setState({ tempType: '', openPopupAddNew: false, selectedTemplate: '', templateName: '', isEditDuration: false })
            }
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  removeKey = (data = [], pharmacy_id) => {
    const newArray = data?.map((obj) => {
      const { ['id']: removedKey, ...newObj } = obj;
      return { ...newObj, pharmacy_id };
    });
    return newArray
  };

  GetPrescriptionData() {
    try {
      let params = ''
      if (this.state.selectedTemplate) {
        params = Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE + `?template_id=${this.state.selectedTemplate?.id}&patient_id=${this.state.PatientData?.patient_id}`
      } else {
        params = Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.state.PatientData?.appointment_id}`
      }
      RestAPIService.getAll(params)
        .then((response) => {
          if (response.data.status === "success") {
            let tempPharmaId = response.data.pharmacy_id
            let pharmaId = this.state.prescriptionData?.prescription_lines?.find(item => item?.pharmacy_id === this.state.selectedPharmacy)?.pharmacy_id
            let externalDrug = this.state.prescriptionData?.prescription_lines?.some((item) => item?.is_external_drug) ? true : false

            if (this.state.selectedTemplate) {
              if (externalDrug || (tempPharmaId === pharmaId) || (this.state.prescriptionData?.prescription_lines?.length === 0 || this.state.prescriptionData?.length === 0)) {
                var NewArray = this.removeKey(response.data.data, response.data.pharmacy_id)
                let Array = [...this.state.prescriptionData?.prescription_lines ? this.state.prescriptionData?.prescription_lines : [], ...NewArray ? NewArray : []]
                const updatedArray = Array?.map((line) => {
                  const { dos_unit, ...rest } = line;
                  return ({
                  ...rest,
                  dosage_unit: line.dos_unit || "Tablet",
                  quantity: line.quantity ? line.quantity : this.calcDuration(line.duration_mode ?? "Days", line.duration ?? 0, null, line) 
                })})
                if (response?.data?.match_generic_list?.length !== 0) {
                  this.setState({
                    hasAllergy: true,
                    addPath: 'template',
                    dupPrescriptionData: this.state.prescriptionData,
                    dupSelectedPharmacy: (Array?.length > 0 && Array[0]?.pharmacy_id) ? Array[0]?.pharmacy_id : "",
                    dupUpdateArray: updatedArray
                  })
                } else {
                  this.state.prescriptionData.prescription_lines = updatedArray;
                  this.setState({
                    prescriptionData: this.state.prescriptionData,
                    selectedTemplate: "",
                    selectedPharmacy: (Array?.length > 0 && Array[0]?.pharmacy_id) ? Array[0]?.pharmacy_id : "",
                  }, () => {
                    this.props.getPrescriptionData(updatedArray)
                  })
                }
              } else {
                this.errorMessage('Selected Template is not matched with selected pharmacy')
              }
            }
            else {
              this.setState({ showAddTemplate: response.data.data?.length > 0 ? true : false })
              const Data = response?.data?.data[0] || [];
              const updatedArray = Data?.prescription_lines?.map((line) => {
                const { dos_unit, ...rest } = line;
                return ({
                ...rest,
                dosage_unit: line.dos_unit ?? "Tablet",
                quantity: line.quantity ? line.quantity : this.calcDuration(line.duration_mode ?? "Days", line.duration ?? 0, null, line)
              })})
              Data["prescription_lines"] = updatedArray || Data?.prescription_lines;
              this.setState({
                prescriptionData: Data ? Data : [],
                transmitted: Data?.is_transmitted ? Data?.is_transmitted : false,
                dupliPrescriptionData: JSON.stringify(Data),
                Recalled: Data?.is_billed_in_pharmacy,
                selectedPharmacy: (Data?.prescription_lines?.length > 0 && Data?.prescription_lines[0]?.pharmacy_id) ? Data?.prescription_lines[0]?.pharmacy_id : "",
              }, () => {
                if (Data?.is_transmitted) {
                  this.props.handleDisableTransfer(true)
                } else if (Data?.is_transmitted === false) {
                  this.props.handleDisableTransfer(false)
                }
                this.props.getPrescriptionData(Data?.prescription_lines || [])
              })
            }
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getPrescriptionListData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              prescriptionTemplateList: response?.data?.data || []
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onEditHandler(data, index) {
    this.setState({
      SelectedEditIndex: index
    }, () => { this.props.EditPrescriptionData(data) })
  }

  onDeleteHandler(data, index) {
    try {
      this.state.prescriptionData?.prescription_lines?.splice(index, 1)
      this.setState({
        prescriptionData: this.state.prescriptionData,
        selectedPharmacy: (this.state.prescriptionData?.prescription_lines?.length > 0 && this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id) ?
          this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id : "",
      }, () => {
        this.setState({ showAddTemplate: this.state.prescriptionData?.length > 0 ? true : false })
        this.props.getPrescriptionData(this.state.prescriptionData?.prescription_lines || [])
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({ isDeleteCliked: false })
  }

  removedPrescription = () => {
    try {
      let removedIds = []; let prescriptionHash = {};
      let duplicate = JSON.parse(this.state.dupliPrescriptionData)
      this.state.prescriptionData?.prescription_lines?.forEach(element => {
        prescriptionHash[element.id] = element
      })

      duplicate?.prescription_lines?.forEach(element => {
        if (!prescriptionHash[element.id]) {
          removedIds.push(element.id)
        }
      })

      return removedIds;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  PostPrescriptionData(fromFav = false, fromTemplate = true) {
    try {
      var states = this.state
      let removedIds = this.state.dupliPrescriptionData ? this.removedPrescription() : []
      let date = this.state.selectedFollowup ? new Date(this.state.selectedFollowup) : null
      let followUpDate = this.state.selectedFollowup ? DateTime.fromJSDate(date).toFormat('yyyy-MM-dd') : null
      let data = {
        appointment_id: this.state.PatientData?.appointment_id,
        deleted_line_ids: removedIds,
        followup_date: this.state.selectedFollowup ? followUpDate : null,
        patient_id: this.state.PatientData?.patient_id,
      }
      if (this.state.prescriptionData?.prescription_id) {
        data.prescription_id = this.state.prescriptionData?.prescription_id
      } else {
        data.pharmacy_id = this.state.selectedPharmacy
      }
      if (this.state.selectedPrescripFav?.length > 0 && fromFav) {
        data.line_items = this.state.selectedPrescripFav?.map((element) => ({
          ...element,
          duration: element.duration ? element.duration : '',
        }));
      }
      else if (this.state.selectedTemplate && fromTemplate) {
        let prescriptionData = []
        this.state.prescriptionData?.prescription_lines?.forEach(element => {
          prescriptionData?.push({
            afternoon: element?.afternoon ? (element?.afternoon)?.toString() : '0',
            brand_name: element?.brand_name ? element?.brand_name : '',
            comments: element?.comments ? element?.comments : '',
            dosage_strength: element.dosage_strength ? element.dosage_strength : '',
            dosage_type: element.dosage_type ? element.dosage_type : '',
            drug_id: element.drug_id ? element.drug_id : '',
            duration: element.duration ? element.duration : '',
            duration_mode: element.duration_mode ? element.duration_mode : '1',
            evening: element.evening ? (element.evening).toString() : '0',
            generic_name: element.generic_name ? element.generic_name : '',
            instructions: element.instructions ? element.instructions : '',
            is_favorite: element.is_favorite,
            morning: element.morning ? (element.morning.toString()) : '0',
            night: element.night ? (element.night).toString() : '0',
            is_unit_ml: element?.is_unit_ml ? element?.is_unit_ml : element?.dosage_unit === "ML",
            tapper_meds: element?.tapper_meds ? element?.tapper_meds : [],
            is_tapper_meds: element?.tapper_meds?.length === 0 ? false : true,
            is_unit_others: element?.is_unit_others ? element?.is_unit_others : element?.dosage_unit === "Others",
            is_external_drug: element?.is_external_drug ? element?.is_external_drug : false,
            dosage_unit : element?.is_unit_ml ? "ML" : element?.is_unit_others ? "Others" : element?.dosage_unit ?? "Tablet",
          })
        })
        data.line_items = prescriptionData
      } else {
        this.state.prescriptionData?.prescription_lines?.forEach(element => {
          element.duration = element.duration ? element.duration : '';
          element.is_tapper_meds = element?.tapper_meds?.length === 0 ? false : true;
          element.is_external_drug = element?.is_external_drug ? element?.is_external_drug : false;
        })
        data.line_items = this.state.prescriptionData?.prescription_lines
      }
      if (data?.line_items?.some((item) => ((item.instructions !== "SOS" && item.instructions !== "STAT") && !item?.duration))) {
        this.errorMessage("Select Duration")
      } else {
        RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION)
          .then((response) => {
            if (response.data.status === "success") {
              this.successMessage(response.data.message)
              this.setState({ isDeleteCliked: false, isEditDuration: false }, () => {
                this.GetPrescriptionData()
                this.getPrescriptionFavouriteData()
                if (is_save_transmit) {
                  setTimeout(() => {
                    this.postPrescriptionTransmit();
                  }, 1000); 
                }
              })
            }
          }).catch(error => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      }


    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  DeleteAllergy() {
    try {
      var states = this.state
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_ALLERGIES + `?id=${states.SelectedList?.id}`, {}).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ isDeleteCliked: false }, () => { this.GetPrescriptionData() })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  renderRecallPopup = () => {
    return (
      <Dialog
        open={this.state.recallPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0.5vw', marginBottom: '0vw' }}>
          <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { this.setState({ recallPopup: false, recallReason: '', recallError: '' }) }} />
        </div>
        <DialogTitle id="alert-dialog-title">
          <Typography component="div">
            Recall Drug
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: '0.8vw' }} id="alert-dialog-description">
            Please provide a reason for recalling this prescription.
          </DialogContentText>
          <TextField
          autoFocus
          multiline
           style={{ marginTop: '1vw' }}
          rows={3}
          fullWidth
          variant="outlined"
          label="Reason for Recall*"
          value={this.state.recallReason || ''}
          onChange={(e) => {
            this.setState({ 
              recallReason: e.target.value,
              recallError: e.target.value.trim() ? '' : 'Reason is required'
            })
          }}
          inputProps={{ maxLength: 150 }}
          error={!!this.state.recallError}
          helperText={this.state.recallError}
          placeholder="Enter the reason for recalling this prescription..."
        />
        </DialogContent>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "flex-end" }}>
          <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button size="small" variant="outlined" sx={{ textTransform: 'capitalize' }} onClick={() => { this.setState({ recallPopup: false, recallReason: '', recallError: '' }) }}>
              {"Close"}
            </Button>
            <Button size="small" variant="contained" sx={{ textTransform: 'capitalize' }} onClick={() => { 
              if (!this.state.recallReason?.trim()) {
                this.setState({ recallError: 'Reason is required' });
                return;
              }
              this.postPrescriptionTransmit(true) 
            }}
             disabled={!this.state.recallReason?.trim()}>
              {"Recall"}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    )
  }

  instructions = (item) => {
    let value = '';
    switch (item) {
      case 'BF':
        value = 'Before Food'
        break;
      case 'AF':
        value = 'After Food'
        break;
      case 'EU':
        value = 'External Use'
        break;
      case 'ES':
        value = 'Empty Stomach'
        break;
      case 'WF':
        value = 'With Food'
        break;
      default:
        value = item;
        break;
    }
    return value;
  }


  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  closeDeletePopup() {
    this.setState({
      deleteTemplateName: null,
      deletePopup: false
    })
  }
  removeDataList = () => {
    try {
      this.setState({ removeData: true })
      RestAPIService.delete(`${Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE}?template_id=${this.state.deleteTemplateName?.id ? this.state.deleteTemplateName?.id : 0}`)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              deletePopup: false,
              deleteTemplateName: null,
              openPopupAddNew: false,
              removeData: false
            }, () => {
              this.successMessage(response?.data?.message);
              this.setState({ removeData: false })
              this.getPrescriptionListData()
            })
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error?.response?.data?.message);
            this.setState({ removeData: false })
          }
        });
    } catch (e) {
      this.errorMessage(e?.message);
      this.setState({ removeData: false })
    }
  }

  getPreviousPrescriptionDatas = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PREVIOUS_PRESCRIPTION_APPOINTMENT + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.state.selectedPrevDate?.appointment}&date=${this.state.selectedPrevDate?.prescription_date}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              prevPrescripData: response.data.prescription_lines,
              match_generic_list: response?.data?.match_generic_list
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPrescriptionFavouriteData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_FAV + '?patient_id=' + this.state.PatientData?.patient_id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              prescriptionFav: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPreviousPrescriptionDates = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PREVIOUS_PRESCRIPTION_APPOINTMENT_DATE_GET + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.props.PatientData?.appointment_id}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              openPrevious: true,
              previousPrescripDate: response.data.prescription,
              selectedPrevDate: response?.data?.prescription[0],
              selectedPrevAppointmentId: response?.data?.prescription[0]?.appointment
            }, () => {
              if (this.state.previousPrescripDate?.length > 0) {
                this.getPreviousPrescriptionDatas()
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  copyPreviousPrescription = () => {
    try {
      let prevPrescriptionData = []
      this.state.prevPrescripData?.forEach(element => {
        prevPrescriptionData?.push({
          afternoon: element?.afternoon ? element?.afternoon : '0',
          brand_name: element?.drug_name ? element?.drug_name : element?.doctor_drug_name ? element?.doctor_drug_name : '',
          comments: element?.comments ? element?.comments : '',
          dosage_strength: element.drug_strength ? element.drug_strength : element?.doctor_drug_strength ? element?.doctor_drug_strength : '',
          dosage_type: element.drug_type ? element.drug_type : element?.doctor_dosagetype ? element?.doctor_dosagetype : '',
          drug_id: element.drug_id ? element.drug_id : '',
          duration: element.duration ? element.duration : '',
          duration_mode: element.duration_mode ? element.duration_mode : '1',
          evening: element.evening ? element.evening : '0',
          generic_name: element.generic_name ? element.generic_name : element?.doctor_generic_name ? element?.doctor_generic_name : '',
          instructions: element.instructions ? element.instructions : '',
          is_favorite: element.is_favorite,
          morning: element.morning ? element.morning : '0',
          night: element.night ? element.night : '0',
          is_unit_ml: element?.is_unit_ml ? element?.is_unit_ml : element?.dosage_unit === "ML",
          is_unit_others: element?.is_unit_others ? element?.is_unit_others : element?.dosage_unit === "Others",
          tapper_meds: element?.tapper_meds ? element?.tapper_meds : [],
          is_tapper_meds: element?.tapper_meds?.length === 0 ? false : true,
          is_external_drug: element?.is_external_drug ? element?.is_external_drug : false,
          dosage_unit : element?.is_unit_ml ? "ML" : element?.is_unit_others ? "Others" : element?.dos_unit ?? "Tablet",
          quantity: element.quantity ? element.quantity : this.calcDuration(element.duration_mode, element.duration, null, element),
          selective_days:element?.selective_days ? element?.selective_days :  [],
          is_high_alert: element?.is_high_alert ? element?.is_high_alert : false,
          is_look_alike: element?.is_lookAlike ? element?.is_lookAlike : false,
          is_sound_alike: element?.is_soundAlike ? element?.is_soundAlike : false,
        })
      })
      let Array = [...this.state.prescriptionData?.prescription_lines ? this.state.prescriptionData?.prescription_lines : [], ...prevPrescriptionData]
      this.state.prescriptionData.prescription_lines = Array
      this.setState({
        prescriptionData: this.state.prescriptionData,
        openPrevious: false,
        selectedPharmacy: (Array?.length > 0 && Array[0]?.pharmacy_id) ? Array[0]?.pharmacy_id : "",
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPreviousPrescriptionPrint = () => {
    try {
      let appointmentId = this.state.selectedPrevDate?.appointment ? this.state.selectedPrevDate?.appointment : this.props.PatientData?.appointment_id
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PREVIOUS_PRESCRIPTION_APPOINTMENT + `?patient_id=${this.props.PatientData?.patient_id}&appointment_id=${appointmentId}&date=${this.state.selectedPrevDate?.prescription_date}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderPreviousPrescriptionPopup = () => {
    try {
      this.state.prevPrescripData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'drug_name', headerName: 'Brand Name', flex: 0.35,
          renderCell: (params) => (
            <Box component={'div'}>
              <Typography fontSize={'0.9vw'} fontWeight={600}>{params?.row?.drug_name}</Typography>
              <Typography fontSize={'0.8vw'}>{`${params?.row?.generic_name} | ${params?.row?.drug_strength} ${params?.row?.drug_type}`}</Typography>
            </Box>
          )
        },
        {
          field: 'morning', headerName: 'M-A-E-N', flex: 0.2,
          renderCell: (params) => {
            const showMl = (params?.row?.is_unit_ml || params?.row?.dosage_unit === "ML") ? "ML" : "";
            return (
            <Box component={'div'}>
              <Typography fontSize={'0.9vw'} fontWeight={600}>{`${params?.row?.morning}${showMl} - ${params?.row?.afternoon}${showMl} - ${params?.row?.evening}${showMl} - ${params?.row?.night}${showMl}`}</Typography>
              <Typography fontSize={'0.8vw'}>{`${params?.row?.duration} ${params?.row?.duration_mode === '1' ? 'Days' : params?.row?.duration_mode === '2' ? 'Weeks' : params?.row?.duration_mode === '3' ? 'Months' : params?.row?.duration_mode === '5' ? 'Alternative Days' : 'Years'}`}</Typography>
            </Box>
          )}
        },
        {
          field: 'instructions', headerName: 'Usage', flex: 0.2,
          renderCell: (params) => (
            <Box component={'div'}>
              <Typography fontSize={'0.9vw'}>{`${this.instructions(params?.row?.instructions)}`}</Typography>
            </Box>
          )
        },
        {
          field: 'comments', headerName: 'Description', flex: 0.25,
          renderCell: (params) => (
            <Box component={'div'}>
              {params?.row?.comments ? params?.row?.comments?.length > 10 ?
                <Tooltip placement='top' title={params?.row?.comments}>
                  <Typography fontSize={'0.9vw'}>{params?.row?.comments?.slice(0, 10) + '...'}</Typography>
                </Tooltip>
                :
                <Typography fontSize={'0.9vw'}>{params?.row?.comments}</Typography> : '-'
              }
            </Box>
          )
        },
      ]
      return (
        <Box component={'div'}>
          <Modal open={this.state.openPrevious}>
            <Box component={'div'} className='eMed_Doc_Notes_Counsellor_Pop_Up'>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} mt={'0.5vw'}>
                <Typography pl={'0.5vw'} fontWeight={600} color={Colors.SecondaryText}>Previous Prescription</Typography>
                <Button
                  onClick={() => {
                    this.setState({ openPrevious: false })
                  }}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1vw'} width={'1.1vw'} />
                </Button>
              </Box>
              <Box component={'div'} display={'flex'} m={'0.5vw'} alignItems={'center'}>
                <Autocomplete
                  size='small'
                  clearIcon
                  sx={{ width: '15vw', mr: '1vw' }}
                  options={this.state.previousPrescripDate}
                  getOptionLabel={(option) => typeof (option) === 'string' ? formatDate(option) : formatDate(option?.prescription_date)}
                  value={this.state.selectedPrevDate}
                  onChange={(e, value) => {
                    this.setState({
                      selectedPrevDate: value
                    }, () => this.getPreviousPrescriptionDatas())
                  }}
                  renderInput={(params) => <TextField {...params} label={'Select Date'} />}
                />
                <Button variant='contained'
                  sx={{ textTransform: 'capitalize', mr: '1vw' }}
                  onClick={() => this.getPreviousPrescriptionPrint()}
                  disabled={this.state.previousPrescripDate?.length > 0 ? false : true}
                >Print</Button>
                <Button variant='contained'
                  sx={{ textTransform: 'capitalize' }}
                  onClick={() => {
                    if (this.state.match_generic_list?.length) {
                      this.setState({ addPath: 'copy', hasAllergy: true })
                    } else {
                      this.copyPreviousPrescription()
                    }
                  }}
                  disabled={this.state.isLocked || this.props.isLocked || (this.state.previousPrescripDate?.length > 0 ? false : true)}
                >Copy</Button>
              </Box>
              <Box component={'div'} sx={{ height: '21vw', m: "0.5vw", overflow: 'auto', border: '1px solid lightgray' }}>
                {/* <DataGrid
                  rows={this.state.prevPrescripData}
                  columns={columns}
                  getRowId={(row) => row['sno']}
                  page={this.state.page}
                  pageSize={this.state.pageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    // Toolbar: CommonGridHeader.CommonToolBar,
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '5vw', left: '20vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  headerHeight={40}
                  disableSelectionOnClick
                  loading={this.state.loading}
                /> */}
                <Table size='small' stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Brand Name</TableCell>
                      <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>M-A-E-N</TableCell>
                      <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Usage</TableCell>
                      <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Description</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.prevPrescripData?.length > 0 ? this.state.prevPrescripData?.map((item, index) => {
                      const showMl = (item?.is_unit_ml || item?.dosage_unit === "ML"|| item?.dos_unit === "ML") ? "ML" : "";
                      return (
                        <TableRow key={index}>
                          {item?.drug_name ? <TableCell>{item?.drug_name ?
                            <Box component={'div'}>
                              <Typography fontSize={'0.9vw'} fontWeight={600}>
                                {item?.drug_name?.length > 15 ? (
                                  <Tooltip placement='top' title={item?.drug_name}>
                                    <div>{item?.drug_name?.slice(0, 15) + '...'}</div>
                                  </Tooltip>
                                ) : (
                                  item?.drug_name
                                )}
                              </Typography>
                              <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                {item?.generic_name ? (
                                  item.generic_name.length > 15 ? (
                                    <Tooltip placement='top' title={item.generic_name}>
                                      <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                    </Tooltip>
                                  ) : (
                                    item.generic_name
                                  )
                                ) : (
                                  '-'
                                )} | {item?.drug_strength ? item.drug_strength : '-'} {item?.drug_type || ''}
                              </Typography>
                            </Box> : '-'
                          }</TableCell> :
                            <TableCell>{item?.doctor_drug_name ?
                              <Box component={'div'}>
                                <Typography fontSize={'0.9vw'} fontWeight={600}>
                                  {item?.doctor_drug_name?.length > 15 ? (
                                    <Tooltip placement='top' title={item?.doctor_drug_name}>
                                      <div>{item?.doctor_drug_name?.slice(0, 15) + '...'}</div>
                                    </Tooltip>
                                  ) : (
                                    item?.doctor_drug_name
                                  )}
                                </Typography>
                                <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                  {item?.doctor_generic_name ? (
                                    item.doctor_generic_name.length > 15 ? (
                                      <Tooltip placement='top' title={item.doctor_generic_name}>
                                        <div>{item.doctor_generic_name.slice(0, 15) + '...'}</div>
                                      </Tooltip>
                                    ) : (
                                      item.doctor_generic_name
                                    )
                                  ) : (
                                    '-'
                                  )} | {item?.doctor_drug_strength ? item.doctor_drug_strength : '-'} {item?.doctor_dosagetype || ''}
                                </Typography>
                              </Box> : '-'
                            }</TableCell>}
                          {item?.tapper_meds?.length > 0 ? null :
                            <><TableCell>
                              <Box component={'div'}>
                                <Typography fontSize={showMl ? '0.8vw' : '0.9vw'} fontWeight={600}>{`${item?.morning ? item?.morning : '0'}${showMl} - ${item?.afternoon ? item?.afternoon : '0'}${showMl} - ${item?.evening ? item?.evening : '0'}${showMl} - ${item?.night ? item?.night : '0'}${showMl}`}</Typography>
                                <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{this.instructions(item?.instructions)}</Typography>
                              </Box>
                            </TableCell>
                              <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{`${item?.duration} ${item?.duration_mode === '1' ? 'Days' : item?.duration_mode === '2' ? 'Weeks' : item?.duration_mode === '3' ? 'Months' : item?.duration_mode === '5' ? 'Alternative Days' : 'Years'}`}</TableCell>
                              <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                                <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                                item?.comments : '-'}</TableCell></>}


                          {item?.tapper_meds?.length > 0 ?
                            <TableCell>
                              {item?.tapper_meds?.map((tapList, tapIndex) => {
                                let date = formatDate(tapList?.start_date) + "-" + formatDate(tapList?.end_date)
                                let mean = tapList?.morning + " - " + tapList?.afternoon + " - " + tapList?.evening + " - " + tapList?.night
                                return (
                                  <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                    {mean?.length > 20 ?
                                      <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{mean?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                      <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.morning ? tapList?.morning : '0'} - ${tapList?.afternoon ? tapList?.afternoon : '0'} - ${tapList?.evening ? tapList?.evening : '0'} - ${tapList?.night ? tapList?.night : '0'}`}</Typography>}
                                    <Typography fontSize={'0.8dvw'}>{this.instructions(tapList?.instructions)}</Typography>
                                    {date?.length > 22 ?
                                      <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{date?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                      <Typography fontSize={'0.8dvw'}>{`${tapList?.start_date ? formatDate(tapList?.start_date) : '-'} - ${tapList?.end_date ? formatDate(tapList?.end_date) : '-'}`}</Typography>
                                    }
                                  </Box>
                                )
                              })}
                            </TableCell> : null}
                          {item?.tapper_meds?.length > 0 ?
                            <TableCell>
                              {item?.tapper_meds?.map((tapList, tapIndex) => {
                                return (
                                  <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                    <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.duration ? tapList?.duration : '-'}`}</Typography>
                                    <Typography fontSize={'0.8dvw'}>{`${tapList?.no_of_dosage ? tapList?.no_of_dosage : '-'}`}</Typography>
                                  </Box>
                                )
                              })}
                            </TableCell> : null}
                          {item?.tapper_meds?.length > 0 ?
                            <TableCell>
                              {item?.tapper_meds?.map((tapList, tapIndex) => {
                                return (
                                  <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiud55'}</Typography>
                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudoki'}</Typography>
                                    {tapList?.comments ? tapList?.comments?.length > 10 ?
                                      <Tooltip placement='top' title={tapList?.comments}><Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                      <Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments}</Typography> : '-'}
                                  </Box>
                                )
                              })}
                            </TableCell> : null}
                        </TableRow>
                      )
                    }) :
                      <TableRow><TableCell align='center' colSpan={4}>No Records To Be Shown</TableCell></TableRow>}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Modal>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  highAlertpopupConfirm = () => {
    this.setState({
      selectedPrescripFav: this.state.selectedData,
    },() => {
      this.setState({
        highAlert: false,
        selectedData: []
      })
    })
  }

  highAlertpopupClose = () => {
    this.setState({
      selectedPrescripFav: [],
      selectedData: []
    },() => {
      this.setState({
        highAlert: false,
      })
    });
  }

  renderFavPopup = () => {
    try {
      return (
        <Box component={'div'}>
          <Modal open={this.state.openFav}>
            <Box component={'div'} className='eMed_Doc_Notes_Prescrip_Fav_Pop_Up'>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} mt={'0.5vw'}>
                <Typography pl={'0.5vw'} fontWeight={600} color={Colors.SecondaryText}>Select From Favourite</Typography>
                <Button
                  onClick={() => this.setState({ openFav: false, selectedPrescripFav: [] })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1vw'} width={'1.1vw'} />
                </Button>
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'center'} mt={'1vw'}>
                <Autocomplete
                  clearIcon
                  size='small'
                  multiple
                  sx={{ width: '20vw' }}
                  options={this.state.prescriptionFav}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.brand_name}
                  value={this.state.selectedPrescripFav}
                  limitTags={3}
                  autoComplete='off'
                  onChange={(event, newValue) => {
                      const hasHighAlert = newValue.some(
                        item => item.is_high_alert || item.is_look_alike || item.is_sound_alike
                      );

                      if (hasHighAlert && this.state.enable_drug_alert) {
                        this.setState({
                          selectedDrug: newValue[0]['drug_name'] || '',
                          is_high_alert: newValue[0]['is_high_alert'] || false,
                          is_look_alike: newValue[0]['is_look_alike'] || false,
                          is_sound_alike: newValue[0]['is_sound_alike'] || false,
                          lookAlikeDrugs: newValue[0]['look_alike_drugs'] || [],
                          SoundAlikeDrugs: newValue[0]['sound_alike_drugs'] || [],
                          selectedData: newValue
                        }, () => {
                          this.setState({
                            highAlert: true
                          })
                        });
                        return;
                      }
                    this.setState({ selectedPrescripFav: newValue })
                  }}
                  renderInput={(params) => <TextField {...params} label='Select Prescription' />}
                />
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                  variant='outlined'
                  onClick={() => this.setState({ selectedPrescripFav: [] })}
                >Clear</Button>
                <Button
                  disabled={this.state.selectedPrescripFav?.length < 0 || this.state.transmitted ? true : false}
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                  variant='contained'
                  onClick={() => {
                    const modifiedArr = this.state.selectedPrescripFav?.map(item => ({...item, dosage_unit: item?.dos_unit ?? "Tablet"}));
                    let Array = [...this.state.prescriptionData?.prescription_lines ? this.state.prescriptionData?.prescription_lines : [], ...modifiedArr]
                    let hasAllergy = this.state.selectedPrescripFav?.some(item => item?.is_allergy)
                    if (hasAllergy) {
                      this.setState({ hasAllergy: true, addPath: 'favorite', dupPrescriptionData: this.state.prescriptionData,dupUpdateArray:Array })
                    } else {
                      this.state.prescriptionData.prescription_lines = Array
                      this.setState({ prescriptionData: this.state.prescriptionData, selectedPrescripFav: [], openFav: false, isEditDuration: false }, () => { })
                    }
                  }}
                >Save</Button>
              </Box>
            </Box>
          </Modal>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderNewTemplatePopup = () => {
    try {
      let { tempType } = this.state
      return (
        <Box component={'div'}>
          <Modal open={this.state.openPopupAddNew}>
            <Box className='eMed_Doc_Notes_Test_Trans_Pop_Up'>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'}>
                <Typography fontWeight={600} color={Colors.SecondaryText}>{tempType === 'Add' ? 'Add New Template' : tempType === 'rename' ? 'Rename Template Name' : 'Delete Template'}</Typography>
              </Box>
              <Box component={'div'}>
                <Box component={'div'} display={'flex'} justifyContent={'center'}>
                  {tempType === 'Add' ?
                    <Box component={'div'} display={'flex'}>
                      {this.state.is_pharmacy ? null :
                        <FormControl size='small' sx={{ width: '12vw', mr: '0.5vw' }}>
                          <InputLabel>Select Pharmacy</InputLabel>
                          <Select
                            label='select Pharmacy'
                            value={this.state.selectedPharmacy}
                            disabled={this.state.prescriptionData?.prescription_lines?.length > 0 && this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id === this.state.selectedPharmacy && this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id}
                            onChange={(e) => this.setState({ selectedPharmacy: e.target.value })}
                          >
                            {this.state.pharmacyList?.length > 0 && this.state.pharmacyList?.map((item, index) => (
                              <MenuItem value={item?.pharmacy_id} key={index}>{item?.pharmacy_name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>}
                      <TextField
                        size='small'
                        sx={{ width: '12vw' }}
                        inputProps={{ maxLength: 75 }}
                        value={this.state.templateName}
                        label='Enter Template Name'
                        onChange={(e) => this.setState({ templateName: e.target.value })}
                      />

                    </Box>
                    : <TextField
                      size='small'
                      sx={{ width: '15vw' }}
                      value={this.state.templateName}
                      label='Enter Template Name'
                      onChange={(e) => this.setState({ templateName: e.target.value })}
                    />
                  }
                </Box>

                <Box component={'div'} display={'flex'} justifyContent={'center'} mt={'0.5vw'}>
                  <Button variant='contained'
                    sx={{ width: '5vw', height: '2vw', textTransform: 'capitalize', mr: '1vw' }}
                    onClick={() => {
                      this.postTemplate()
                    }}
                  >Add</Button>
                  <Button variant='outlined'
                    sx={{ width: '5vw', height: '2vw', textTransform: 'capitalize' }}
                    onClick={() => this.setState({ tempType: '', openPopupAddNew: false, templateName: "" })}
                  >Close</Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPrescriptionPrint = () => {
    try {
      RestAPIService.getAllTwo(Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_PRINT + `?prescription_id=${this.state.prescriptionData?.prescription_id ? this.state.prescriptionData?.prescription_id : ""}&clinic_id=${this.state.clinicId ? this.state.clinicId : ""}&language=${this.state.selectedLanguage}&appointment_id=${this.props.PatientData?.appointment_id ? this.props.PatientData?.appointment_id : ""}`)
        .then((response) => {
          this.setState({ isEditDuration: false })
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  ClosesuccessPopUp = () => {
    this.setState({
      successPopup: false
    })
  }

  renderSuccessPopup = () => {
    return (
      <div>
        <Modal
          open={true}
        >
          <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'30vh'}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2vw' }}>
              <Box sx={{ display: 'flex', gap: '1vw' }}>
                <img src={ImagePaths.Tick.default} alt='success' />
                <Typography fontWeight={600}>{this.state.successPopupTxt ? this.state.successPopupTxt : 'Transmitted Successfully'}</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: '1vw' }}>
                {this.state.smsSuccessTxt ? <ErrorIcon color='error' /> : <img src={ImagePaths.Tick.default} alt='success' />}
                <Typography fontWeight={600}>{this.state.smsSuccessTxt ? this.state.smsSuccessTxt : 'SMS Sent Successfully'}</Typography>
              </Box>
            </Box>
            <Box display={'flex'} gap={'0.5vw'}>
              <Button sx={{ textTransform: 'capitalize', }} size="small" variant="outlined" onClick={this.ClosesuccessPopUp}>{"OK"}</Button>
            </Box>
          </Box>
        </Modal>
      </div>
    )
  }

  renderGrpEdit = () => {
    return (
      <Box>
        <Dialog open={this.state.grpEdit}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <DialogTitle fontSize={'1vw'}>Update Duration</DialogTitle>
            <IconButton size='small' onClick={() => this.setState({
              grpEdit: false,
              selectedDays: '',
              selectedDuration: '1',
              tempSelectedDays: '',
              tempSelectedDuration: '1',
            })}>
              <Box component={'img'} src={ImagePaths.LabCloseButton.default} sx={{ width: '.8vw', height: '.8vw' }} />
            </IconButton>
          </Box>

          <DialogContent sx={{ width: '30vw' }}>
            <Box sx={{ display: "flex", flexDirection: "row", marginY: "0.5vw" }}>
              <Autocomplete
                disableClearable
                forcePopupIcon={true}
                size="small"
                style={{ width: "14vw" }}
                value={this.state.tempSelectedDays ?? this.state.selectedDays}
                options={
                  this.state.tempSelectedDuration === "1" ? Days :
                    this.state.tempSelectedDuration === "2" ? Weeks :
                      this.state.tempSelectedDuration === "3" ? Months :
                        this.state.tempSelectedDuration === "5" ? Days : Year
                }
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option?.label
                }
                onChange={(event, newValue) => {
                  this.setState({ tempSelectedDays: newValue });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Duration" />
                )}
              />

              <Box
                component="div"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                pr="1vw"
                pl="0.8vw"
              >
                <FormControl size="small">
                  <InputLabel>Select Duration</InputLabel>
                  <Select
                    sx={{ width: "14vw" }}
                    label="Select Duration"
                    value={this.state.tempSelectedDuration ?? this.state.selectedDuration}
                    onChange={(e) => {
                      this.setState({
                        tempSelectedDuration: e.target.value,
                        tempSelectedDays: '', // reset days when duration changes
                        selectedDays: ''
                      });
                    }}
                  >
                    <MenuItem value="1">Days</MenuItem>
                    <MenuItem value="2">Weeks</MenuItem>
                    <MenuItem value="3">Months</MenuItem>
                    <MenuItem value="4">Years</MenuItem>
                    <MenuItem value="5">Alternative Days</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => this.setState({
                grpEdit: false,
                selectedDays: '',
                selectedDuration: '1',
                tempSelectedDays: '',
                tempSelectedDuration: '1',
              })}
              variant='outlined'
              sx={{ textTransform: 'capitalize' }}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                // Update the state only on Update Changes button click
                const newPrescripData = { ...this.state.prescriptionData };
                const updatedPrescriptionLines = newPrescripData.prescription_lines?.map((line) => ({
                  ...line,
                  duration: this.state.tempSelectedDays ? this.state.tempSelectedDays.value : line.duration,
                  duration_mode: this.state.tempSelectedDuration ?? line.duration_mode,
                  quantity: line.quantity ? line.quantity : this.calcDuration(this.state.tempSelectedDuration ?? line.duration_mode, this.state.tempSelectedDays ? this.state.tempSelectedDays.value : line.duration, null, line)
                }));

                newPrescripData.prescription_lines = updatedPrescriptionLines;

                this.setState({
                  prescriptionData: newPrescripData,
                  selectedDays: this.state.tempSelectedDays,
                  selectedDuration: this.state.tempSelectedDuration,
                  grpEdit: false,
                  selectedDays: '',
                  selectedDuration: '1',
                  tempSelectedDays: '',
                  tempSelectedDuration: '1',
                });
              }}
              variant='contained'
              sx={{ textTransform: 'capitalize' }}
              color="primary"
            >
              Update Changes
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

  isTabletOrCapsule = (type) => type === 'Tablet' || type === 'Capsule';

  calcDuration = (durationMode, duration, index, item) => {
    if (durationMode && duration && !item.is_unit_ml && this.isTabletOrCapsule(item.dosage_type)) {
      try {
        let qty = Math.round(item.morning || 0) + Math.round(item.afternoon || 0) + Math.round(item.evening || 0) + Math.round(item.night || 0);
        let calcQty = 0;
        switch (durationMode) {
          case '1':
            calcQty = +(qty) * +(duration) * 1;
            break;
          case '2':
            if (duration === "Once In a Week") {
              calcQty = +(qty) * 1;
            } else if (duration === "Twice In a Week") {
              calcQty = +(qty) * 2;
            } else {
              calcQty = +(qty) * +(duration) * 7;
            }
            break;
          case '3':
            if (duration === "Once In a Month") {
              calcQty = +(qty) * 1;
            } else if (duration === "Twice In a Month") {
              calcQty = +(qty) * 2;
            } else {
              calcQty = +(qty) * +(duration) * 30;
            }
            break;
          case '4':
            if (duration !== "Chronic") {
              calcQty = +(qty) * +(duration) * 365;
            } else {
              calcQty = 0
            }
            break;
          case '5':
            calcQty = +(qty) * Math.round(+(duration) / 2);
            break;
        }
        return calcQty ?? 0;
      } catch (error) {
        this.errorMessage(error.message)
      }
    }
    return 0;
  }

  confirmSave = () => {
    if (this.state.addPath === 'copy') {
      this.copyPreviousPrescription()
        setTimeout(() => {
          this.setState({
            dupPrescriptionData: [],
            dupSelectedPharmacy: null,
            dupUpdateArray: [],
            hasAllergy: false,
            addPath: ''
          })
        }, 500)
    } else if (this.state.addPath === 'favorite') {
      this.state.prescriptionData.prescription_lines = this.state.dupUpdateArray
      this.setState({ prescriptionData: this.state.prescriptionData, selectedPrescripFav: [], openFav: false, isEditDuration: false }, () => {
        setTimeout(() => {
          this.setState({
            dupPrescriptionData: [],
            dupSelectedPharmacy: null,
            dupUpdateArray: [],
            hasAllergy: false,
            addPath: ''
          })
        }, 50)
      })
    } else if (this.state.addPath === 'template') {
      this.state.prescriptionData.prescription_lines = this.state.dupUpdateArray
      this.setState({
        prescriptionData: this.state.dupPrescriptionData,
        selectedTemplate: "",
        selectedPharmacy: this.state.dupSelectedPharmacy,
      }, () => {
        this.props.getPrescriptionData(this.state.dupUpdateArray)
        setTimeout(() => {
          this.setState({
            dupPrescriptionData: [],
            dupSelectedPharmacy: null,
            dupUpdateArray: [],
            hasAllergy: false,
            addPath: ''
          })
        }, 50)
      })
    }
  }

  popClose = () => {
    if (this.state.addPath === 'copy') {
      this.setState({ hasAllergy: false, addPath: '' })
    } else if (this.state.addPath === 'favorite') {
      this.setState({ hasAllergy: false, addPath: '', selectedPrescripFav: [], openFav: false, isEditDuration: false })
    } else if (this.state.addPath === 'template') {
      this.setState({
        dupPrescriptionData: [],
        dupSelectedPharmacy: null,
        dupUpdateArray: [],
        hasAllergy: false,
        addPath: ''
      })
    }
  }

  render() {
    try {
      const { t } = this.props
      let prescriptionData = this.state.prescriptionData?.prescription_lines ? this.state.prescriptionData?.prescription_lines : this.state.prescriptionData || [];
      return (
        <ShowComponents onIntersection={this.GetIntialData.bind(this)}>
          <Box minHeight={'30vh'} overflow={'auto'}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', m: '0.5dvw 1dvw' }} visibility={this.state.SelectedEditIndex === null ? 'visible' : 'hidden'}>
              <Box>
                {(this.state.is_pharmacy || is_save_transmit) ? null :
                  <Tooltip placement='top' title='Transmit'>
                    <Button
                      variant='contained'
                      className='Common_Btn_Min_Width'
                      sx={{ height: '1.9vw', width: '1.9vw', mr: '0.3vw' }}
                      disabled={this.state.isLocked || this.props.isLocked || this.state.transmitted}
                      // onClick={() => this.getPharmacyList(false, true)}
                      onClick={() => {
                        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null;
                        let pharmaList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)) : [];
                        this.setState({
                          selectedPharmacy: prescriptionData[0]?.pharmacy_id ? prescriptionData[0]?.pharmacy_id : (pharmaList?.length ? pharmaList[0]?.pharmacy_id : "")
                        }, () => {
                          this.postPrescriptionTransmit()
                        })
                      }
                      }
                    >
                      <CompareArrowsIcon />
                    </Button>
                  </Tooltip>
                }
                <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => {
                    this.setState({ openPrevious: false }, () => {
                      this.getPreviousPrescriptionDates()
                    })
                  }}
                >
                  <Tooltip placement='top' title={this.state.isOPT ? 'Previous Medication' : "Previous Prescription"}>
                    <Box component={'img'} src={ImagePaths.PreviousPrescription.default} sx={{ height: '1.7vw', width: '1.7vw' }} />
                  </Tooltip>
                </Button>
                <Button
                  className='Common_Btn_Min_Width'
                  disabled={this.state.isLocked || this.props.isLocked}
                  onClick={() => this.setState({ openFav: true })}
                >
                  <Tooltip placement='top' title='favorite'>
                    <Box component={'img'} src={ImagePaths.StarUnfill.default} sx={{ height: '1.7vw', width: '1.7vw' }} />
                  </Tooltip>
                </Button>
                {this.state.Recalled == false && this.state.transmitted && !this.props.isLocked ? <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => { this.setState({ recallPopup: true }) }}
                >
                  <Tooltip placement='top' title='Recall'>
                    <div style={{ backgroundColor: "#b8170d", borderRadius: "0.2vw" }}>
                      <Box component={'img'} src={ImagePaths.Recall.default} height={'1.7vw'} width={'1.7vw'} />
                    </div>
                  </Tooltip>
                </Button> : null}
              </Box>
              <Box component={'div'} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '0.5dvw' }}>
                <Autocomplete
                  size='small'
                  disabled={this.state.isLocked || this.props.isLocked || this.state.transmitted}
                  sx={{ width: '13vw', mr: '0.5vw' }}
                  options={this.state.prescriptionTemplateList?.filter(item => {
                    const pharmacyId = (this.state.prescriptionData?.prescription_lines?.length > 0 && this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id) ||
                      (this.state.prescriptionData?.length > 0 && this.state.prescriptionData[0]?.pharmacy_id) ||
                      this.state.selectedPharmacy;
                    return pharmacyId ? item?.pharmacy_id === pharmacyId : true
                  })}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option.template_name}
                  value={this.state.selectedTemplate}
                  limitTags={3}
                  autoComplete='off'
                  onChange={(event, newValue) => {
                    this.setState({
                      selectedTemplate: newValue,
                      isEditDuration: false
                    }, () => {
                      if (newValue) { this.GetPrescriptionData() }
                    })
                  }}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} style={{ padding: "0vh 1.2vh" }}>
                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', padding: 0 }}>
                          <ListItemText primary={option?.template_name && option?.template_name?.length > 14 ?
                            <Tooltip placement='top' title={option?.template_name}>
                              {<div>{option?.template_name?.slice(0, 14) + '...'}</div>}
                            </Tooltip> : option?.template_name} />
                          <IconButton
                            edge="end"
                            color="error"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({
                                tempType: 'delete',
                                deleteTemplateName: option,
                                deletePopup: true
                              });
                            }}
                          >
                            <Tooltip placement='top' title={"Delete"} arrow>
                              <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} /> </Tooltip>
                          </IconButton>
                        </ListItem>
                      </li>
                    );
                  }}
                  renderInput={(params) => <TextField {...params} me label='Select Template' />}
                  PaperComponent={({ children }) => {
                    return (
                      <Paper component={'div'}>
                        {children}
                        {this.state.showAddTemplate ? <Button
                          color="primary"
                          fullWidth
                          sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                          onMouseDown={(e) => {
                            this.setState({ openPopupAddNew: true, tempType: 'Add' })
                          }}
                        >
                          Add Template
                        </Button> : null}
                        {/* {this.state.selectedTemplate ?
                          <Box component={'div'}>
                            <Button
                              color="primary"
                              fullWidth
                              sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                              onMouseDown={(e) => {
                                this.setState({ openPopupAddNew: true, tempType: 'rename', templateName: this.state.selectedTemplate?.template_name })
                              }}
                            >
                              Rename
                            </Button>
                            <Button
                              color="primary"
                              fullWidth
                              sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                              onMouseDown={(e) => {
                                this.setState({ deletePopup: true })
                              }}
                            >
                              Delete
                            </Button>
                          </Box> : null
                        } */}

                      </Paper>
                    )
                  }}
                />
                <Box component={'div'}>
                  <Select
                    size='small'
                    sx={{ width: '10vw' }}
                    value={this.state.selectedLanguage}
                    onChange={(e) => this.setState({ selectedLanguage: e.target.value })}
                  >
                    {this.state.languageList?.map((item, index) => (
                      <MenuItem value={item?.value} key={index}>{item?.label}</MenuItem>
                    ))}
                  </Select>
                </Box>
                <Box component={'div'}>
                  <Button
                    className='Common_Btn_Min_Width'
                    onClick={() => { this.getPrescriptionPrint() }}
                    disabled={!(prescriptionData?.length > 0)}
                  >
                    <Tooltip placement='top' title='Print'>
                      <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
                    </Tooltip>
                  </Button>
                </Box>
                <Button
                  variant='contained'
                  disabled={this.props.isLocked || this.state.transmitted}
                  size='small'
                  onClick={() => { this.PostPrescriptionData() }}>{is_save_transmit ? "Save & Transmit": "Save"}</Button>
              </Box>
            </Box>
            <Box component={'div'} ref={this.boxRef} border={'1px solid lightgray'} maxHeight={"70vh"} overflow={'auto'}>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell width={'2%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Favourite</TableCell>
                    <TableCell width={'31%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Prescription</TableCell>
                    <TableCell width={'26%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>M-A-E-N</TableCell>
                    <TableCell width={'17%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>
                      {"Duration"}
                      <Tooltip placement='top' title={this.state.isEditDuration ? 'Save' : 'Edit'} arrow>
                        <IconButton className='eMed_edit_btn_bill' disabled={this.props.isLocked || this.state.transmitted || prescriptionData?.length === 0} sx={{ mb: "0.5vh" }}
                          onClick={() => {
                            this.setState({ isEditDuration: !this.state.isEditDuration }, () => {
                            })
                          }}
                        >
                          <img className='eMed_header_img' src={this.state.isEditDuration ? ImagePaths.TickEnable.default : ImagePaths.NewEditcon.default} alt='edit' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip placement='top' title={'Add Group Duration'} arrow>
                        <IconButton className='eMed_edit_btn_bill' disabled={this.props.isLocked || this.state.transmitted || prescriptionData?.length === 0} sx={{ mb: "0.5vh" }}
                          onClick={() => { this.setState({ grpEdit: true, isEditDuration: false }) }}
                        >
                          <img className='eMed_header_img' src={ImagePaths.GroupAdd.default} alt='edit' />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    {showQty && <TableCell width={'20%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Quantity</TableCell>}
                    <TableCell width={'20%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Comments</TableCell>
                    <TableCell width={'5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {prescriptionData?.length > 0 ? prescriptionData?.map((item, index) => {
                    const showMl = (item?.is_unit_ml || item?.dosage_unit === "ML") ? "ML" : ""
                    return(
                    <TableRow key={index}>
                      <TableCell>
                        <Box component={'div'}>
                          {/* <Button sx={{ visibility: (item?.drug_id || item?.drug_ms_id) ? "visible" : "hidden", justifyContent: 'flex-start', paddingTop: '0.5vw', }} */}
                          <Button sx={{ justifyContent: 'flex-start', paddingTop: '0.5vw', }}
                            className='Common_Btn_Min_Width'
                            disabled={this.props.isLocked || this.state.transmitted}
                            onClick={() => {
                              this.state.prescriptionData.prescription_lines[index].is_favorite = !this.state.prescriptionData?.prescription_lines[index].is_favorite
                              this.setState({
                                prescriptionData: this.state.prescriptionData,
                                selectedPharmacy: (this.state.prescriptionData?.prescription_lines?.length > 0 && this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id) ?
                                  this.state.prescriptionData?.prescription_lines[0]?.pharmacy_id : "",
                              },
                                () => { this.props.getPrescriptionData(this.state.prescriptionData?.prescription_lines || []) })
                            }}>
                            <Box component={'img'} src={item?.is_favorite ? ImagePaths.StarFill.default : ImagePaths.StarUnfill.default} height={'1.5vw'} width={'1.5vw'} />

                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell style={{ color: (item?.high_alert || item?.is_high_alert) && this.state.enable_drug_alert ? 'red' : 'inherit' }}>{item?.brand_name ?
                        <Box component={'div'}>
                          <Typography fontSize={'0.9vw'} fontWeight={600}>
                            {item?.brand_name?.length > 15 ? (
                              <Tooltip placement='top' title={item?.brand_name}>
                                <div>{item?.brand_name?.slice(0, 15) + '...'}</div>
                              </Tooltip>
                            ) : (
                              item?.brand_name
                            )}
                          </Typography>
                          <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                            {item?.generic_name ? (
                              item.generic_name.length > 15 ? (
                                <Tooltip placement='top' title={item.generic_name}>
                                  <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                </Tooltip>
                              ) : (
                                item.generic_name
                              )
                            ) : (
                              '-'
                            )} | {item?.dosage_strength ? item.dosage_strength : '-'} {item?.dosage_type || ''}
                          </Typography>
                        </Box> : '-'
                      }</TableCell>
                      {item?.tapper_meds?.length > 0 ? null :
                        <><TableCell>
                          <Box component={'div'}>
                            <Typography fontSize={showMl ? '0.8vw' : '0.9vw'} fontWeight={600}>{`${item?.morning ? item?.morning : '0'}${showMl} - ${item?.afternoon ? item?.afternoon : '0'}${showMl} - ${item?.evening ? item?.evening : '0'}${showMl} - ${item?.night ? item?.night : '0'}${showMl}`}</Typography>
                            <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{this.instructions(item?.instructions)}</Typography>
                          </Box>
                        </TableCell>

                          <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                            {this.state.isEditDuration ?
                              (<Box sx={{ display: "flex", flexDirection: "row", marginY: "0.5vw" }}>
                                <Autocomplete
                                  disableClearable
                                  forcePopupIcon={true}
                                  size="small" style={{ width: "6vw" }}
                                  value={item?.duration || ""}
                                  options={item.duration_mode === "1" ? Days : item.duration_mode === "2" ? Weeks : item.duration_mode === "3" ? Months : item.duration_mode === "5" ? Days : Year}
                                  getOptionLabel={(option) => typeof (option) === "string" ? option : (option?.label)}
                                  onChange={(event, newValue) => {
                                    let newPrescripData = { ...this.state.prescriptionData };
                                    let updatedPrescriptionLines = [...newPrescripData?.prescription_lines];
                                    updatedPrescriptionLines[index] = {
                                      ...updatedPrescriptionLines[index],
                                      duration: newValue ? newValue.value : null,
                                      quantity: this.calcDuration(updatedPrescriptionLines[index]?.duration_mode, newValue.value || null, index, updatedPrescriptionLines[index]) || 0,
                                    };
                                    newPrescripData.prescription_lines = updatedPrescriptionLines;
                                    this.setState({ prescriptionData: newPrescripData });
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={t('Select Duration')}
                                    />
                                  )} />
                                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} pr={"1vw"} pl={'0.8vw'}>
                                  <FormControl size='small'>
                                    <InputLabel>Select Duration</InputLabel>
                                    <Select
                                      sx={{ width: '6vw' }}
                                      label='Select Duration'
                                      value={item.duration_mode || ""}
                                      onChange={(e) => {
                                        let newPrescripData = { ...this.state.prescriptionData };
                                        let updatedPrescriptionLines = [...newPrescripData?.prescription_lines];
                                        updatedPrescriptionLines[index] = {
                                          ...updatedPrescriptionLines[index],
                                          duration_mode: e.target.value,
                                          duration: "",
                                          quantity: 0,
                                        };
                                        newPrescripData.prescription_lines = updatedPrescriptionLines;
                                        this.setState({ prescriptionData: newPrescripData });
                                      }}
                                    >
                                      <MenuItem value={'1'}>Days</MenuItem>
                                      <MenuItem value={'2'}>Weeks</MenuItem>
                                      <MenuItem value={'3'}>Months</MenuItem>
                                      <MenuItem value={'4'}>Years</MenuItem>
                                      <MenuItem value={'5'}>Alternative Days</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>
                              </Box>) :
                              <>
                                {item?.duration?.label || item?.duration ? `${item?.duration ? item?.duration : item?.duration?.label ? item?.duration?.label : '-'} ${item?.duration_mode === '1' ? 'Days' : item?.duration_mode === '2' ? 'Weeks' : item?.duration_mode === '3' ? 'Months' : item?.duration_mode === '5' ? 'Alternative Days' : 'Years'}` : '-'}
                              </>
                            }

                          </TableCell>
                          {showQty && <TableCell width={'20%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                        {this.state.isEditDuration ? (<TextField
                          autoComplete='off'
                          sx={{ width: '100%' }}
                          size='small'
                          value={item.quantity ?? ""}
                          inputProps={{ maxLength: 25 }}
                          onChange={(e) => {
                            let newPrescripData = { ...this.state.prescriptionData };
                            let updatedPrescriptionLines = [...newPrescripData?.prescription_lines];
                            updatedPrescriptionLines[index] = {
                              ...updatedPrescriptionLines[index],
                              quantity: e.target.value ? e.target.value : 0,
                            };
                            newPrescripData.prescription_lines = updatedPrescriptionLines;
                            this.setState({ prescriptionData: newPrescripData });
                          }}
                              label={'Quantity'}
                          />) : (item?.quantity?.length > 10 ?
                                <Tooltip placement='top' title={item?.quantity}>
                                  <Typography fontWeight={600}>{item?.quantity?.slice(0, 10) + '...'}</Typography>
                                </Tooltip> :
                                <Typography fontWeight={600}>{item?.quantity ?? 0}</Typography>)}</TableCell>}
                        </>}

                      {/* Tapper Med Table Column Starts ========> */}
                      {item?.tapper_meds?.length > 0 ?
                        <TableCell>
                          {item?.tapper_meds?.map((tapList, tapIndex) => {
                            let date = formatDate(tapList?.start_date) + "-" + formatDate(tapList?.end_date)
                            let mean = tapList?.morning + " - " + tapList?.afternoon + " - " + tapList?.evening + " - " + tapList?.night
                            return (
                              <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                {mean?.length > 20 ?
                                  <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{mean?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.morning ? tapList?.morning : '0'} - ${tapList?.afternoon ? tapList?.afternoon : '0'} - ${tapList?.evening ? tapList?.evening : '0'} - ${tapList?.night ? tapList?.night : '0'}`}</Typography>}
                                <Typography fontSize={'0.8dvw'}>{this.instructions(tapList?.instructions)}</Typography>
                                {date?.length > 22 ?
                                  <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{date?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8dvw'}>{`${tapList?.start_date ? formatDate(tapList?.start_date) : '-'} - ${tapList?.end_date ? formatDate(tapList?.end_date) : '-'}`}</Typography>
                                }
                              </Box>
                            )
                          })}
                        </TableCell> : null}
                      {item?.tapper_meds?.length > 0 ?
                        <TableCell>
                          {item?.tapper_meds?.map((tapList, tapIndex) => {
                            return (
                              <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.duration ? tapList?.duration : '-'}`}</Typography>
                                {tapList?.no_of_dosage ? tapList?.no_of_dosage?.length > 10 ?
                                  <Tooltip placement='top' title={tapList?.no_of_dosage}><Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage}</Typography> : '-'}
                              </Box>
                            )
                          })}
                        </TableCell> : null}
                      {showQty && item?.tapper_meds?.length > 0 &&
                        <TableCell width={'20%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                          {item?.tapper_meds?.map((tapList, tapIndex) => {
                            return (
                              <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                <Typography fontSize={'0.8dvw'} fontWeight={600}>{(tapList?.quantity ?? 0)}</Typography>
                                <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                              </Box>
                            )
                          })}
                        </TableCell>}
                      {/* {item?.tapper_meds?.length > 0 ?
                        <TableCell>
                          {item?.tapper_meds?.map((tapList, tapIndex) => {
                            return (
                              <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiud55'}</Typography>
                                <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudoki'}</Typography>
                                {tapList?.comments ? tapList?.comments?.length > 10 ?
                                  <Tooltip placement='top' title={tapList?.comments}><Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                  <Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments}</Typography> : '-'}
                              </Box>
                            )
                          })}
                        </TableCell> : null} */}
                      {/* Tapper Med Table Column Ends ========> */}
                      <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                        <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                        item?.comments : '-'}</TableCell>
                      <TableCell >
                        <Box sx={{ fontSize: '0.9vw', fontWeight: 600, display: 'flex' }}>
                          <CommonEditButton size={"1.5vw"} disable={this.props.isLocked || this.state.transmitted} onClick={this.onEditHandler.bind(this, item, index)} />
                          <CommonDeleteButton size={"1.5vw"} disable={this.props.isLocked || this.state.SelectedEditIndex !== null || this.state.transmitted} onClick={this.onDeleteHandler.bind(this, item, index)} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}) :
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell><Typography sx={{ fontSize: '0.9vw', paddingTop: '6vh', paddingBottom: '6vh' }}>No Records To Be Shown</Typography></TableCell>
                      <TableCell />
                      <TableCell />
                      <TableCell />
                    </TableRow>
                  }
                </TableBody>
              </Table>
            </Box>
          </Box>
          {this.state.isErrorMsg ?
            <ToastMsg
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {
            this.state.deletePopup ?
              <DeletePopup
                DeletTitle={`${t("Are you sure you want to delete")}  ${this.state.deleteTemplateName?.template_name ? this.state.deleteTemplateName?.template_name : "-"} ?`}
                deleteAlertPopupClose={this.closeDeletePopup.bind(this)}
                removeData={this.removeDataList.bind(this)}
                disable={this.state.removeData}
              />
              : null
          }
          {this.state.grpEdit ? this.renderGrpEdit() : null}
          {this.state.successPopup ? this.renderSuccessPopup() : null}
          {this.renderPreviousPrescriptionPopup()}
          {this.renderNewTemplatePopup()}
          {this.renderFavPopup()}
          {this.renderRecallPopup()}
          {
            this.state.hasAllergy ?
              <ConfirmPopup
                cnfTitle={'Confirm'}
                cnfContent={"This generic name is listed in the patient's medication allergies. Are you sure you want to proceed?"}
                cnfAlertPopupClose={this.popClose}
                cnfData={this.confirmSave}
                btnText2={"Proceed"}
              />
              : null
          }
          {this.state.highAlert && this.state.enable_drug_alert ?
            <HighAlertDrugPopup
              selectedDrug={this.state.selectedDrug}
              is_high_alert={this.state.is_high_alert}
              is_lookAlike={this.state.is_look_alike}
              is_soundAlike={this.state.is_sound_alike}
              lookAlikeDrugs={this.state.lookAlikeDrugs}
              soundAlikeDrugs={this.state.SoundAlikeDrugs}
              onCancel={this.highAlertpopupClose.bind(this)}
              onConfirm={this.highAlertpopupConfirm.bind(this)}
            /> : null}
        </ShowComponents>
      )
    }
    catch (e) {
      console.log(e.message);
      return null
    }
  }
}
export default withTranslation()(DocPrescriptionLeft)
